import { useTranslation } from 'react-i18next';
import { GateScreen, GateStatus } from '../components';

interface Props {
  onRetry: () => void;
  onBack: () => void;
  uuid?: string;
  timeLeft?: string;
}

const GateRetryPage = ({ onRetry, onBack, uuid, timeLeft }: Props) => {
  const { t } = useTranslation();

  return (
    <GateScreen
      uuid={uuid}
      timeLeft={timeLeft}
      actions={[
        { label: t('waiting.tryAgain'), onClick: onRetry, variant: 'green' },
        { label: t('common.back'), onClick: onBack, variant: 'grey', dataSentryElement: 'onepage-retry-back' },
      ]}
    >
      <GateStatus tone="warning" title={t('gate.noRequisitesTitle')} text={t('gate.noRequisitesText')} />
    </GateScreen>
  );
};

export default GateRetryPage;
